export default "__VITE_ASSET__CkOP7MIq__"